import Link from 'next/link'
import Image from 'next/image'

interface IImageProps {
  src: string
  height: number
  width: number
  alt: string
  href: string
}

const ImageLink = ({ href, src, width, height, alt }: IImageProps) => {
  return (
    <Link href={href} className="h-full">
      <Image
        className={`h-[${height}px]`}
        loading="eager"
        src={src}
        width={width}
        height={height}
        alt={alt}
      />
    </Link>
  )
}
export default ImageLink
